import { of } from "rxjs";
import { combineEpics } from "redux-observable";
import * as ReduxObservablesEpicUtils from "@ane/core/lib/utils/ReduxObservablesEpicUtils";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import { loadFlightTrafficActionTypes, loadingFlightTraffic, loadedFlightTraffic } from "./FlightTraffic.ducks.js";
import FlightResource from "../../resources/Flight.resource.js";
const getFlightTrafficEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic({
  filterOnType: loadFlightTrafficActionTypes.LOAD,
  loadResource: (payload) => {
    return FlightResource.loadFlightTraffic(
      payload.flightId,
      payload.managementGroup,
      EnvironmentService.getWorkspaceIdOrDefault(payload.workspaceId),
      false
    );
  },
  loadingAction: (payload) => loadingFlightTraffic(payload.flightId, payload.workspaceId, payload.managementGroup),
  loadedAction: (successData, payload, error) => {
    return of(loadedFlightTraffic(payload.flightId, payload.workspaceId, payload.managementGroup, successData, error || ""));
  }
});
const FlightTrafficEpics = combineEpics(getFlightTrafficEpic);
export {
  FlightTrafficEpics as default,
  getFlightTrafficEpic
};
//# sourceMappingURL=FlightTraffic.epics.js.map
